import React from 'react';

const DashboardHeader = ({ user, onLogout, isDarkMode, toggleDarkMode }) => {
  // Asegurarse de que user no sea null antes de intentar acceder a sus propiedades
  const displayUsername = user ? user.username : 'Invitado';

  return (
    <header className={`${isDarkMode ? 'bg-gray-900/80 border-gray-700' : 'bg-white/90 border-gray-200'} shadow-lg backdrop-blur-md border-b z-10 relative`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center">
              <svg className="h-9 w-9 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span className={`ml-2 text-2xl font-extrabold tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Card Checker <span className="text-indigo-500">Pro</span></span>
            </div>
          </div>
          <div className="flex items-center">
            <div className="hidden md:ml-4 md:flex-shrink-0 md:flex md:items-center">
              {/* Dark Mode Toggle */}
              <button
                onClick={toggleDarkMode}
                className={`p-2 rounded-full ${isDarkMode ? 'text-gray-400 hover:bg-gray-700' : 'text-gray-500 hover:bg-gray-100'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors`}
              >
                {isDarkMode ? (
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h1M3 12H2m8.003-9.997l-.707-.707M10.707 2.293L9.997 3M13.997 2.293l.707-.707M13.293 3.003l.707.707M6.293 6.293L5.586 5.586M6.997 5.586l-.707.707M17.707 6.293l.707-.707M17.003 5.586l.707.707M21 12h-1M4 12H3m15.364-6.364l-.707-.707M18.071 5.586l-.707.707M5.636 18.364l-.707-.707M6.343 17.657l-.707.707M18.364 18.364l-.707-.707M17.657 19.071l-.707-.707M12 18a6 6 0 110-12 6 6 0 010 12z" />
                  </svg>
                ) : (
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                  </svg>
                )}
              </button>

              <div className="ml-3 relative flex items-center">
                <div className={`text-base font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mr-4`}>
                  Hola, {displayUsername}
                </div>
                <button
                  onClick={onLogout}
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors transform hover:scale-105"
                >
                  Cerrar sesión
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;